import axios, { AxiosResponse } from 'axios';
import { AUTH_LOCALSTORAGE, BASE_URL, NAVIGATION_LOGS } from './constants';
import { handleError } from './errorHandler';
type Method = 'get' | 'post' | 'put' | 'delete' | 'patch';
const timeout = 240_000;


const APPLICATION_JSON_TYPE = 'application/json';
const APPLICATION_MULTIPART = 'multipart/form-data';
const createRequest = async <RequestDataType, ResponseType>(
  method: Method,
  endpoint: string,
  data?: RequestDataType,
  isFormData = false,
  contentType = APPLICATION_JSON_TYPE
) => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);
  const api = axios.create({
    baseURL: BASE_URL,
    headers: {
      accept: APPLICATION_JSON_TYPE,
      'Content-Type':isFormData? APPLICATION_MULTIPART:contentType,
      Authorization: token ? `Bearer ${token}` : false,
    },
    timeout: timeout,
  })

  try {
    api.interceptors.request.use((config) => {
      const token = localStorage.getItem(AUTH_LOCALSTORAGE);
    
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    
      config.headers['x-session-id'] =
        sessionStorage.getItem('session_id') || '';
    
      config.headers['x-client-time'] = new Date().toISOString();
    
      return config;
    });
    api.interceptors.response.use(
      (response) => {
        if (response.config.url?.includes(NAVIGATION_LOGS)) {
          return response;
        }

        // Fire-and-forget: o log de navegação nunca deve atrasar a resposta.
        void api.post(NAVIGATION_LOGS, {
          type: 'API',
          action: response.config.method?.toUpperCase(),
          endpoint: response.config.url,
          statusCode: response.status,
          timestamp: new Date().toISOString(),
          page:window.location.pathname,
          sessionId: sessionStorage.getItem('session_id')??"",
          userAgent: navigator.userAgent,

        }).catch(() => {});

        return response;
      },
      (error) => {
        if (error.config?.url?.includes(NAVIGATION_LOGS)) {
          return Promise.reject(error);
        }

        // Fire-and-forget: o log de erro nunca deve atrasar a rejeição.
        void api.post(NAVIGATION_LOGS, {
          type: 'ERROR',
          action: error.config?.method?.toUpperCase(),
          endpoint: error.config?.url,
          statusCode: error.response?.status,
          error: error.message,
          page:window.location.pathname,
          sessionId: sessionStorage.getItem('session_id')??"",
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
        }).catch(() => {});

        return Promise.reject(error);
      }
    );
    const response = await api.request<
      RequestDataType,
      AxiosResponse<ResponseType>
    >({ method, url: endpoint, data: data ? data : {} })

    

    return response.data
  } catch (error) {
    throw new Error(handleError(error));
  }
}
export const get = async <ResponseType, RequestDataType = never>(
  endpoint: string
) => await createRequest<RequestDataType, ResponseType>('get', endpoint)

export const post = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType,
  isFormData = false,
) => await createRequest<RequestDataType, ResponseType>('post', endpoint, data,isFormData)


export const put = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('put', endpoint, data)

export const patch = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('patch', endpoint, data)

export const del = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) =>
  await createRequest<RequestDataType, ResponseType>('delete', endpoint, data)

  export const delEmptyBody = async <ResponseType, RequestDataType = never>(
  endpoint: string,
) =>
  await createRequest<RequestDataType, ResponseType>('delete', endpoint)

  export const postBlob = async <RequestDataType>(
  endpoint: string,
  data: RequestDataType
): Promise<Blob> => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);

  try {
    const response = await axios.post(endpoint, data, {
      baseURL: BASE_URL,
      headers: {
        'Content-Type': APPLICATION_JSON_TYPE,
        Accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        Authorization: token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      timeout: timeout,
    });

    return response.data;
  } catch (error) {
    throw new Error(handleError(error));
  }
};

export const postFormData = async <ResponseType>(
  endpoint: string,
  formData: FormData
): Promise<ResponseType> => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);

  try {
    const response = await axios.post(endpoint, formData, {
      baseURL: BASE_URL,
      headers: {
        Accept: APPLICATION_JSON_TYPE,
        Authorization: token ? `Bearer ${token}` : '',
      },
      timeout,
    });

    return response.data;
  } catch (error) {
    throw new Error(handleError(error));
  }
};


export const getBlob = async (endpoint: string): Promise<Blob> => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);

  const finalUrl =
    endpoint.startsWith('http') || endpoint.startsWith('/')
      ? endpoint
      : `${BASE_URL}${endpoint}`;

  try {
    const response = await axios.get(finalUrl, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      timeout,
    });

    return response.data;
  } catch (error) {
    throw new Error(handleError(error));
  }
};

export const getBlobV2 = async (endpoint: string): Promise<Blob> => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);
  if(endpoint.includes(BASE_URL!)){
      endpoint = endpoint.replace(BASE_URL!, '').trim();
  }
  try {
    const response = await axios.get(endpoint, {
      baseURL: BASE_URL,
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      timeout,
    });
    return response.data;
  } catch (error) {
    throw new Error(handleError(error));
  }
};





